const FORMATOS_SOPORTADOS = {
  'image/png': { formato: 'png', mimeType: 'image/png', extension: 'png' },
  'image/x-png': { formato: 'png', mimeType: 'image/png', extension: 'png' },
  'image/jpeg': { formato: 'jpeg', mimeType: 'image/jpeg', extension: 'jpg' },
  'image/jpg': { formato: 'jpeg', mimeType: 'image/jpeg', extension: 'jpg' },
  'image/pjpeg': { formato: 'jpeg', mimeType: 'image/jpeg', extension: 'jpg' },
  'image/gif': { formato: 'gif', mimeType: 'image/gif', extension: 'gif' },
  'image/bmp': { formato: 'bmp', mimeType: 'image/bmp', extension: 'bmp' },
  'image/x-bmp': { formato: 'bmp', mimeType: 'image/bmp', extension: 'bmp' },
  'image/x-ms-bmp': { formato: 'bmp', mimeType: 'image/bmp', extension: 'bmp' },
  'image/x-windows-bmp': { formato: 'bmp', mimeType: 'image/bmp', extension: 'bmp' },
}

function errorImagen(code, message, detail = {}) {
  return { code, message, detail }
}

function decodificarBase64(contenido) {
  if (
    !contenido ||
    contenido.length % 4 !== 0 ||
    !/^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(contenido)
  ) {
    return null
  }

  try {
    const binario = atob(contenido)
    const bytes = new Uint8Array(binario.length)
    for (let i = 0; i < binario.length; i++) {
      bytes[i] = binario.charCodeAt(i)
    }
    return bytes
  } catch (error) {
    return null
  }
}

function uint16BE(bytes, offset) {
  return (bytes[offset] << 8) | bytes[offset + 1]
}

function uint16LE(bytes, offset) {
  return bytes[offset] | (bytes[offset + 1] << 8)
}

function uint32BE(bytes, offset) {
  return (
    bytes[offset] * 0x1000000 +
    (bytes[offset + 1] << 16) +
    (bytes[offset + 2] << 8) +
    bytes[offset + 3]
  )
}

function uint32LE(bytes, offset) {
  return (
    bytes[offset] +
    bytes[offset + 1] * 0x100 +
    bytes[offset + 2] * 0x10000 +
    bytes[offset + 3] * 0x1000000
  )
}

function int32LE(bytes, offset) {
  const valor =
    bytes[offset] |
    (bytes[offset + 1] << 8) |
    (bytes[offset + 2] << 16) |
    (bytes[offset + 3] << 24)
  return valor
}

function dimensionesPng(bytes) {
  const firma = [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a]
  if (bytes.length < 45 || !firma.every((byte, i) => bytes[i] === byte)) return null

  let offset = 8
  let width = 0
  let height = 0
  let encontroIdat = false
  let encontroIend = false

  while (offset + 12 <= bytes.length) {
    const longitud = uint32BE(bytes, offset)
    const finalChunk = offset + 12 + longitud
    if (!Number.isSafeInteger(longitud) || finalChunk > bytes.length) return null

    const tipo = String.fromCharCode(...bytes.slice(offset + 4, offset + 8))
    if (offset === 8) {
      if (tipo !== 'IHDR' || longitud !== 13) return null
      width = uint32BE(bytes, offset + 8)
      height = uint32BE(bytes, offset + 12)
    }
    if (tipo === 'IDAT') encontroIdat = true
    if (tipo === 'IEND') {
      if (longitud !== 0 || finalChunk !== bytes.length) return null
      encontroIend = true
      break
    }
    offset = finalChunk
  }

  if (!encontroIdat || !encontroIend) return null
  return { formato: 'png', width, height }
}

function dimensionesGif(bytes) {
  if (bytes.length < 10) return null
  const cabecera = String.fromCharCode(...bytes.slice(0, 6))
  if (
    (cabecera !== 'GIF87a' && cabecera !== 'GIF89a') ||
    bytes[bytes.length - 1] !== 0x3b
  ) {
    return null
  }

  return { formato: 'gif', width: uint16LE(bytes, 6), height: uint16LE(bytes, 8) }
}

function dimensionesBmp(bytes) {
  if (bytes.length < 26 || bytes[0] !== 0x42 || bytes[1] !== 0x4d) return null
  const tamanoArchivo = uint32LE(bytes, 2)
  const offsetPixeles = uint32LE(bytes, 10)
  if (tamanoArchivo !== bytes.length || offsetPixeles >= bytes.length) return null

  const tamanoCabecera = Math.abs(int32LE(bytes, 14))
  if (tamanoCabecera === 12) {
    return { formato: 'bmp', width: uint16LE(bytes, 18), height: uint16LE(bytes, 20) }
  }
  if (tamanoCabecera < 40) return null

  return {
    formato: 'bmp',
    width: Math.abs(int32LE(bytes, 18)),
    height: Math.abs(int32LE(bytes, 22)),
  }
}

function dimensionesJpeg(bytes) {
  if (
    bytes.length < 4 ||
    bytes[0] !== 0xff ||
    bytes[1] !== 0xd8 ||
    bytes[bytes.length - 2] !== 0xff ||
    bytes[bytes.length - 1] !== 0xd9
  ) {
    return null
  }

  const marcadoresSof = new Set([
    0xc0,
    0xc1,
    0xc2,
    0xc3,
    0xc5,
    0xc6,
    0xc7,
    0xc9,
    0xca,
    0xcb,
    0xcd,
    0xce,
    0xcf,
  ])

  let offset = 2
  while (offset < bytes.length) {
    while (offset < bytes.length && bytes[offset] === 0xff) offset++
    if (offset >= bytes.length) break

    const marcador = bytes[offset++]
    if (marcador === 0xd9 || marcador === 0xda) break
    if (marcador === 0x01 || (marcador >= 0xd0 && marcador <= 0xd7)) continue
    if (offset + 1 >= bytes.length) return null

    const longitud = uint16BE(bytes, offset)
    if (longitud < 2 || offset + longitud > bytes.length) return null

    if (marcadoresSof.has(marcador)) {
      if (longitud < 7) return null
      return {
        formato: 'jpeg',
        width: uint16BE(bytes, offset + 5),
        height: uint16BE(bytes, offset + 3),
      }
    }

    offset += longitud
  }

  return null
}

function detectarFormato(bytes) {
  return dimensionesPng(bytes) || dimensionesJpeg(bytes) || dimensionesGif(bytes) || dimensionesBmp(bytes)
}

export function analizarBase64Imagen(valor) {
  if (typeof valor !== 'string') {
    return {
      ok: false,
      error: errorImagen('image_value_not_string', 'El valor de imagen no es una cadena'),
    }
  }

  const limpio = valor.trim()
  const dataUrlMatch = limpio.match(/^data:([^;,]+);base64,([^\s]+)$/)
  if (!dataUrlMatch) {
    return {
      ok: false,
      error: errorImagen(
        'image_data_url_invalid',
        'La imagen debe ser un data URL base64 válido y sin parámetros adicionales'
      ),
    }
  }

  const mimeDeclarado = dataUrlMatch[1].toLowerCase()
  const formatoEsperado = FORMATOS_SOPORTADOS[mimeDeclarado]
  if (!formatoEsperado) {
    return {
      ok: false,
      error: errorImagen('image_mime_unsupported', 'El tipo de imagen no está soportado', {
        mimeType: mimeDeclarado,
        supportedMimeTypes: Object.keys(FORMATOS_SOPORTADOS),
      }),
    }
  }

  const contenido = dataUrlMatch[2]
  const bytes = decodificarBase64(contenido)
  if (!bytes) {
    return {
      ok: false,
      error: errorImagen('image_base64_invalid', 'El contenido base64 de la imagen no es válido'),
    }
  }

  const detectado = detectarFormato(bytes)
  if (!detectado || detectado.formato !== formatoEsperado.formato) {
    return {
      ok: false,
      error: errorImagen(
        'image_signature_mismatch',
        'El contenido binario no coincide con el tipo de imagen declarado',
        { mimeType: mimeDeclarado, detectedFormat: detectado?.formato || null }
      ),
    }
  }

  if (!detectado.width || !detectado.height) {
    return {
      ok: false,
      error: errorImagen('image_dimensions_invalid', 'La imagen no tiene dimensiones válidas'),
    }
  }

  return {
    ok: true,
    imagen: {
      mimeType: formatoEsperado.mimeType,
      extension: formatoEsperado.extension,
      contenido,
      width: detectado.width,
      height: detectado.height,
    },
  }
}

export function esBase64Imagen(valor) {
  return analizarBase64Imagen(valor).ok
}

export function normalizarBase64Imagen(valor) {
  const resultado = analizarBase64Imagen(valor)
  return resultado.ok ? resultado.imagen : null
}
